<template>
  <div class="index">
    <div class="maincont">
      <div class="title" :class="{bgfff:showNews.catalog == 'news' || showNews.catalog == 'activity'}">
        <span class="shu"></span>
        <span class="name">{{topTitle[catalog]}}</span>
      </div>
      <div class="contbox">
        <div v-if="showNews.catalog == 'news' || showNews.catalog == 'activity'">
          <div class="newstitle" v-html="showNews.title"></div>
          <div class="tips">
            <span>{{showNews.createTime}}</span>
            <span>阅读：{{showNews.viewTime}}</span>
            <!-- <span>来源：中国人民日报</span> -->
          </div>
          <div class="reading flex">
            <div class="guide">导读</div>
            <div class="description">{{showNews.description}}</div>
          </div>
        </div>
        <div class="cont" v-html="showNews.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from '@/Mixins/mixin_3g48.js'
export default {
  mixins:[mixins],
  data() {
    return {
      articleId: '', // 文章id
      content: '', // 内容
      areaNameStr: '', // 区域名
      showNews: {}, // 渲染上去的数据
      isNews: false, // 判断是否是新闻或者活动
      // toptitle: '', // 上面的红线后面的标题
      tableData: [], // 请求接受的数据

      topTitle: {
        briefIntroduction: '简介',
        idea: '理念',
        culture: '文化',
        team: '团队',
        routeLine: '路线',
        contactUs: '联系我们',
        news: '新闻',
        activity: '活动',
        knowledge: '知识产权',
        website: '网站管理',
        privacy: '隐私保护',
        especially: '特别声明',
        signUp: '注册登录',
        companyVip: '单位会员',
        personalVip: '个人会员',
        video: '如何视频',
      },
    }
  },
  computed: {
    catalog() {
      return this.$route.query.catalog || 'briefIntroduction'
    },
  },
  watch: {
    catalog(val) {
      this.scrollHandle(640, '')
      // document.documentElement.scrollTop = 640
      this.getDataByNavName(this.catalog)
    },
    pageAreaId_x() {
      this.getData()
    }
  },
  methods:{
    scrollHandle(height, cb) {
      // 实现滚动效果
      let top = document.documentElement.scrollTop || document.body.scrollTop
      const timeTop = setInterval(() => {
        if (top - height < -100) {
          top += 100
        } else if (top - height > 100) {
          top -= 100
        } else {
          top = height
        }
        document.documentElement.scrollTop = top
        if (top === height) {
          clearInterval(timeTop)//先滚动，再发数据请求
          cb && cb()
        }
      }, 10)
    },
    getData() {
      this.areaNameStr = this.$route.query.areaNameStr
      this.toptitle = this.$route.query.toptitle
      if (this.$route.query.id) {
        this.getDataById(this.$route.query.id)
      } else {
        if (this.$route.query.catalog == undefined) {
          this.getDataByNavName('briefIntroduction')
        } else {
          this.getDataByNavName(this.$route.query.catalog)
        }
      }
    },
    getDataById(id) { // 通过点击列表中的新闻或者活动进入该路由
      let reqData = {}
      reqData.id = id
      reqData.includeParentSite = true
      this.$api.util_search('xinwen', reqData).then(res =>{
        if (res.data.status === 0) {
          let _r = JSON.parse(res.data.data)
          this.tableData = _r
          this.showNews = this.tableData[0]
        } else {
          this._status(res.data)
        }
      })
    },
    getDataByNavName(catalog) { // 通过点击菜单栏进入路由
      let reqData = {}
      reqData.catalog = catalog
      let allArticleArr = ['knowledge','website','privacy','especially','signUp','companyVip','personalVip','video'] // 网站全局文章   分类
      if (allArticleArr.indexOf(catalog) != -1) { // 查询全局文章
        this.$api.util_search('wenzhang', reqData).then(res =>{
          if (res.data.status === 0) {
            let _r = JSON.parse(res.data.data)
            this.tableData = _r
            this.showNews = this.tableData[0]
          } else {
            this._status(res.data)
          }
        })
      } else {
        reqData.areaId = this.pageAreaId_x
        reqData.includeParentSite = true
        this.$api.util_search('xinwen', reqData).then(res =>{
          if (res.data.status === 0) {
            let _r = JSON.parse(res.data.data)
            if (_r.length > 0) {
              this.tableData = _r
              this.showNews = this.tableData[0]
            } else {
              this.showNews.content = '暂无内容'
            }
          } else {
            this._status(res.data)
          }
        })
      }
    },
  },
  created() {
    this.getData()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      console.log(document.documentElement.scrollTop)
      if (!['articleList', 'articleDetail', 'article'].includes(from.name)) {
        document.documentElement.scrollTop = 0
      } else {
        document.documentElement.scrollTop = 640
        // vm.scrollHandle(640, '')
        // let timer = setTimeout(() => {
        //   vm.scrollHandle(640, '')
        //   clearTimeout(timer)
        // }, 300)
      }
    })
  }
}
</script>

<style lang='scss' scoped>
.title{position: relative;height: 50px;line-height: 50px;padding: 0 15px;border: 1px solid #eeeeee;background-color: #f2f2f2;}
.title .shu{display: inline-block;border: 1.5px solid red;height: 18px;position: absolute;top: 15px;}
.title .name{display: inline-block;margin-left: 10px;}
.title .search{position: absolute;right: 0px;display: inline-block;padding: 0px;}
.title .search i{cursor: pointer;}


/deep/.maincont .title .search input{
  border-radius: 15px;
}
.contbox{
  padding: 30px;
}
.contbox .newstitle{
  line-height: 45px;
  font-weight: bold;
  font-size: 30px;
  text-align: center;
  margin-bottom: 15px;
}
.contbox .tips{
  color: #999;
  font-size: 12px;
  width: 80%;
  margin: 10px auto 25px;
  display: flex;
  justify-content: space-around;
}
.contbox .reading{
  display: flex;
  align-items: stretch; 
  border: 1px solid #eeeeee;
  background-color: #f3f3f3;
  margin-bottom: 40px;
}
.contbox .reading .guide{
  display:flex;
  justify-content:center;
  align-items:center;
  width: 150px;
  background-color: #ffffff;
  color: #1E9FFF;
  padding: 10px;
}
.contbox .reading .description{
  padding: 10px;
  font-size: 16px;
  line-height: 1.6;
  color: #666666
}
.contbox .cont{
  font-size: 18px;
  line-height: 1.8;
}
</style>